document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details

  // Load metafield data
  const allVariantMetafieldData = JSON.parse(document.querySelector('#variant_metafield_data').textContent);

  //replace content
  const VariantDetailsTextElement = document.querySelector('.accordion__content');
  VariantDetailsTextElement.innerHTML = allVariantMetafieldData[variant.id];
});

window.onload = function() {
  document.querySelectorAll('a[href="https://keyopticaleurope.com/en/brand-srt-en/"], a[href="https://keyopticaleurope.com/brand-sabrinaregeturo/"]').forEach(function(link) {
      link.setAttribute("target", "_blank");
  });
};